import styled from 'styled-components';

export const DivDropStyled = styled.div`
  border-radius:.28571429rem;
  border: 1px solid rgba(34,36,38,.15);
  padding: 5px;
  margin: 3px 0;
  position: fixed;
  z-index: 1;
  background: white;
  max-height: 10em;
  overflow: auto;
`;

export const DivInnerDropStyled = styled.div`
  padding: 3px;
  ${({ disabled }) => disabled && 'filter: grayscale(1) opacity(.275);'}
  &:hover{
    background: linear-gradient(0deg,rgba(255,255,255,0.88),rgba(255,255,255,0.88)),#4281C9;
  }
`;
